import makeStyles from '@mui/styles/makeStyles';

import { colors } from '@/themesConfig/colors';

export const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      height: '100%',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.text.primary,
      overflow: 'hidden',

      display: 'flex',
      alignItems: 'center',

      margin: '40px 72px 104px',
      borderRadius: theme.spacing(1),

      [theme.breakpoints.down('laptop')]: {
        margin: '40px 56px',
      },

      [theme.breakpoints.down('tablet')]: {
        margin: 0,
        borderRadius: 0,
      },
    },

    leftSide: {
      flex: '2',
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      maxHeight: 'min(1000px, 90%)',
      overflowY: 'auto',
    },

    rightSide: {
      flex: 3,
      display: 'flex',
      flexDirection: 'column',

      backgroundColor: colors.black,
      width: '100%',
      height: '100%',

      [theme.breakpoints.down('laptop')]: {
        flex: 2,
        maxWidth: '50%',
      },

      [theme.breakpoints.down('mobile')]: {
        display: 'none',
      },
    },

    marketingText: {
      fontSize: '72px',
      maxWidth: 'min(1300px, 90%)',
      padding: '60px 124px 0 64px',

      [theme.breakpoints.down('desktop')]: {
        fontSize: '64px',
        padding: '60px 32px 0 64px',
      },

      [theme.breakpoints.down('netbook')]: {
        fontSize: '48px',
      },

      [theme.breakpoints.down('tablet')]: {
        fontSize: '36px',
        padding: '60px 32px 0 24px',
      },
    },

    landingImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  }),
  {
    name: 'LandingWrapper',
  },
);
